import React from "react";
import { Link } from "react-router-dom";

function About() {
  return (
    <div class="md:py-16">
      <div class="max-w-screen-xl mx-auto p-5 md:p-4 ">
        <h1 class="text-4xl font-semibold pb-5">About Us</h1>
        <h1 class="text-2xl font-semibold pb-5">
          Welcome to <span class="text-[#31c48d]"> Live Number Generator.</span>
        </h1>
        <p class="text-md pb-5">
          Your Easy, Reliable, and Efficient Tool for Generating Random Numbers
          <br />
          <br />
          Live Number Generator is your simple, reliable tool for generating random

          
          numbers. Whether you're picking a winner, running a lucky draw,
          rolling virtual dice, or need a quick number between two values, we’ve
          got you covered. <br />
          <br />
          We created this app to make random number generation quick, fair, and
          easy to use. With no ads or distractions, you’ll enjoy a clean,
          straightforward interface that works on any device.
          <br />
          <br />
          Our mission is to provide a user-friendly platform that ensures
          fairness and randomness for your everyday needs. We're always
          improving our features and performance, listening to your feedback to
          make your experience even better. <br /> Thanks for choosing Number
          Picker! We hope you enjoy using our tool, and we're committed to
          delivering the highest quality random number generator available.
          <br />
          <br />
          Thank you for using Live Number Generator! Hope you enjoy using <b>Live Number Generator.</b>
        </p>
        <div class="info">
          <p class="text-md pb-5">
            Our mission is to produce the highest quality true Number Pickers
            and make them available to the world in useful forms.
          </p>
          <div class="md:flex justify-between mt-5">
            <div class="mb-4 md:mb-0 w-full md:w-[15%] font-semibold">
              Registered Office
            </div>
            <div class="w-full md:w-[85%]">
              Xclusive Web Designs LTD
              <br />
              325 Days Rd, Grange, QLD, Australia
            </div>
          </div>
          <div class="md:flex justify-between mt-5">
            <div class="mb-4 md:mb-0 w-full md:w-[15%] font-semibold">
              Contact
            </div>
            <div class="w-full md:w-[85%]">
              Web:
              <a href="/" data-discover="true">
                https://livenumbergenerator.com/
              </a>
              <br />
              Email:
              <a href="mailto:info@numberpicker.net"> info@livenumbergenerator </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
